module.exports = __webpack_public_path__ + "img/circle.97db7aca.svg";